<template>
        <el-card style="width: 100%">
            <div
                    slot="header"
                    class="clearfix"
            >
                <span>Áfa kimutatás - ügynöki</span>
            </div>
            <div class="filter-container">
                <el-form
                        label-position="top"
                >
                    <el-row :gutter="20">
                        <el-col :span="20" style="display: flex; ">
                            <el-form-item
                                    label="Dátum"
                            >
                                <el-date-picker
                                        v-model="dateRange"
                                        type="daterange"
                                        :clearable="false"
                                        format="yyyy. MM. dd."
                                        value-format="yyyy-MM-dd"
                                        :picker-options="dateRangeOptions"
                                        style="margin-right: 10px;"
                                        @change="handleDateRangeOptionChange"
                                />
                            </el-form-item>
                            <el-form-item style="margin-right: 10px;"
                                    label="Képviselő"
                            >
                                <el-select
                                        v-model="representativeUserId"
                                        v-loading="userLoading"
                                        filterable
                                        @change="handleRepresentativeSelectChange"
                                >
                                    <el-option
                                            v-for="user in representativeUsers"
                                            :key="user.id"
                                            :value="user.id"
                                            :label="user.full_name"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="4">
                            <div style="text-align: right; margin-top: 24px;">
                                <el-button
                                        :loading="downloadLoading"
                                        icon="el-icon-download"
                                        @click="download"
                                >
                                    Letöltés
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-loading="loading">
                <el-table
                        :key="tableKey"
                        :data="vatValues.values.data"
                        style="width: 100%"
                        row-key="id"
                        border
                >
                    <el-table-column
                            width="50"
                            prop="count"
                            label="#"
                            fixed
                    >
                        <template slot-scope="scope">
                            {{ scope.row.creator_user_id }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="150"
                            prop="count"
                            label="Képviselő"
                            show-overflow-tooltip
                            fixed
                    >
                        <template slot-scope="scope">
                            {{ scope.row.creator_user_name }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            width="100"
                            prop="count"
                            label="Kelt"
                            align="left"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.issue_date }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            width="100"
                            prop="count"
                            label="Teljesítés"
                            align="left"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.delivery_date }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            width="135"
                            prop="count"
                            label="Számla"
                            align="left"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.receipt_number }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            width="135"
                            prop="count"
                            label="Sztornó"
                            align="left"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.cancelled_receipt_number }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            width="250"
                            prop="count"
                            label="Vevő"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.customer }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            width="60"
                            prop="count"
                            label="Irsz"
                            align="left"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.postal_code }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            width="120"
                            prop="count"
                            label="Település"
                            show-overflow-tooltip
                            align="left"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.city }}
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="count"
                            label="Cím"
                            show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.address }}
                        </template>
                    </el-table-column>

                    <div v-for="vat in vatValues.vats">
                        <el-table-column
                                width="100"
                                prop="count"
                                :label="'Nettó ' + vat + '%'"
                                align="right"
                        >
                            <template slot-scope="scope">
                                {{ scope.row['net_price_' + vat] | currency }}
                            </template>
                        </el-table-column>

                        <el-table-column
                                width="100"
                                prop="count"
                                :label="'Áfa ' + vat + '%'"
                                align="right"
                        >
                            <template slot-scope="scope">
                                {{ scope.row['vat_' + vat] | currency }}
                            </template>
                        </el-table-column>
                    </div>

                    <el-table-column
                            width="140"
                            prop="count"
                            label="Számla br."
                            align="right"
                            fixed="right"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.gross_price | currency }}
                        </template>
                    </el-table-column>

                </el-table>

                <div class="el-card-footer">
                    <el-pagination
                        background
                        :current-page="currentPage"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="parseInt(vatValues.values.per_page)"
                        layout="total, prev, pager, next"
                        :total="vatValues.values.total"
                        @current-change="handleCurrentChange"
                    />
                </div>
            </div>
        </el-card>
</template>

<script>
    import moment from 'moment';
    import { saveAs } from 'file-saver';


    export default {
        components: {
        },
        data() {
            const start = moment()
                .startOf('year')
                .format('Y-MM-DD');
            const end = moment()
                .format('Y-MM-DD');
            return {
                tableKey: 0,
                itemLoading: 0,
                vatValues: {
                    values: {},
                    vats: [],
                },
                loading: false,
                downloadLoading: false,
                userLoading: false,
                representativeUserId: null,
                representativeUsers: [],
                currentPage: 1,
                dateRange: [start, end],
                dateRangeOptions: {
                    firstDayOfWeek: 1,
                    shortcuts: [{
                        text: 'Aktuális hét',
                        onClick(picker) {
                            const start = moment()
                                .weekday(1)
                                .toDate();
                            const end = moment()
                                .weekday(7)
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző hét',
                        onClick(picker) {
                            const start = moment()
                                .subtract({weeks: 1})
                                .weekday(1)
                                .toDate();
                            const end = moment()
                                .subtract({weeks: 1})
                                .weekday(7)
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Aktuális hónap',
                        onClick(picker) {
                            const start = moment()
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .endOf('month')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző hónap',
                        onClick(picker) {
                            const start = moment()
                                .subtract({months: 1})
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .subtract({months: 1})
                                .endOf('month')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző 3 hónap',
                        onClick(picker) {
                            const start = moment()
                                .subtract({months: 3})
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .subtract({months: 1})
                                .endOf('month')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Aktuális év',
                        onClick(picker) {
                            const start = moment()
                                .startOf('year')
                                .toDate();
                            const end = moment()
                                .endOf('year')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Előző év',
                        onClick(picker) {
                            const start = moment()
                                .subtract({years: 1})
                                .startOf('year')
                                .toDate();
                            const end = moment()
                                .subtract({years: 1})
                                .endOf('year')
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'YTD',
                        onClick(picker) {
                            const start = moment()
                                .startOf('year')
                                .toDate();
                            const end = moment()
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'MTD',
                        onClick(picker) {
                            const start = moment()
                                .startOf('month')
                                .toDate();
                            const end = moment()
                                .toDate();
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            };
        },
        computed: {

        },
        watch: {},
        async mounted() {
            this.fetchData();

            this.userLoading = true;
            try {
                this.representativeUsers = await axios.get('api/users/representatives');
            } catch (e) {}
            this.userLoading = false;
        },
        methods: {
            async download() {
                this.downloadLoading = true;
                try {
                    const excel = await axios({
                        url: `api/reports/vat/representative/detailed/download`,
                        method: 'POST',
                        responseType: 'blob',
                        data: {
                            from: this.dateRange[0],
                            to: this.dateRange[1],
                            representative_id: this.representativeUserId
                        },
                    });
                    saveAs(excel, `vatrepresentativedetailed.xlsx`);
                } catch (e) {}
                this.downloadLoading = false;
            },

            async fetchData() {
                this.loading = true;
                let query = `api/reports/vat/representative/detailed/${this.dateRange.join(',')}?page=${this.currentPage}&`

                if (this.representativeUserId) {
                    query += `representative_id=${this.representativeUserId}`
                }

                this.vatValues = await axios.get(query);
                this.loading = false;
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.fetchData();
            },

            handleDateRangeOptionChange() {
                this.currentPage = 1;
                this.fetchData();
            },

            handleRepresentativeSelectChange() {
                this.currentPage = 1;
                this.fetchData();
            }
        },
    };
</script>
<style lang="scss">
    .stockValue-table {
        .el-table__footer {
            td {
                .cell {
                    font-weight: 700;
                }
            }
        }
    }
</style>
